import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import '../pages/landing/landing.css';

const PageNotFound = () => {
    const { t } = useTranslation();
    return (
        <div className="mb-landing">
            <div className="mb-landing-badge" aria-hidden="true">🍽️</div>
            <h1>{t('errors.page_not_found_heading')}</h1>
            <p>{t('errors.page_not_found_body')}</p>
            <Link to="/" className="mb-landing-note" style={{ textDecoration: 'none', color: '#c2613f', fontWeight: 600 }}>
                {t('common.back_to_start')}
            </Link>
        </div>
    );
}

export default PageNotFound;
